export const performanceCn = {
  performanceNew: {
    to: "至",
    AttendanceStatus: "出勤状态",
    AttendanceTime: "出勤时间",
    Last7days: "最近一周",
    quicklink: "直达链接",
    OPlog: "操作log",
    precomplete: "预完成",
    inbound: "呼入",
    bound: "呼出",
    APIcall: "api直拨",
    softphonecall: "分机直拨",
    stopCollection: "停催",
    cancelStopCollection: "取消停催",
    selectDate: "选择日期",
    isSureCancel: "是否确定取消停催？"
  },
  warningLetter: {
    warningletters: '警告信列表',
    Download: '下载',
    notDownloaded: '未下载',
    alreadyDownloaded: '已下载',
    alreadySended: '已发送',
    sendSuccessfully: '发送成功',
    pleaseDownloadFirstly: '请先下载',
  },
  urgeLetter: {
    urgeletter: '催收函',
    Download: '下载',
    selectUrgeLetter: '选择模板',
  },
  relation: {
    companyPhone: "公司电话",
    person2: "联系人2",
    person3: "联系人3",
    self: "本人",
    role: "角色",
    person1: "联系人1",
    DispalyNum: "主叫号码",
    DestNum: "目标号码",
    BillID: "话单id",
    Direction: "呼叫方向",
    IsnotConnect: "是否接通",
    OnboardTime: "入职时间",
    WAContext: "发送内容(WA)",
    WaitingDuration: "接通前等待时长"
  },
  CallRecordQuery: {
    RecordingMethod: "记录方式",
    RecordingFile: "录音文件",
    Supplier: "供应商"
  },
  RiskReport: {
    RiskReport: "风险上报",
    Risk: "风险"
  },
  CommonParam: {
    ParameterName: "参数名",
    ParameterDescription: "参数描述",
    OperatingTime: "操作时间",
    Operator: "操作人",
    ParameterValue: "参数值"
  },
  salaryReport: {
    timelimit: "时间范围",
    whetherthenewstaffofthemonth: "是否当月新入职员工",
    basesalary: "基础工资",
    isthefirstofthestaffIDnumber5: "员工工号首位是否为5",
    basicdailywage: "每日基本工资",
    actualbasicsalary: "实际基本工资",
    staffcreatetime: "员工创建时间",
    CurrentCycle: "当前周期",
    LastCycle: "上个周期",
    CurrentMonth: "当前月",
    Wagetimerange: "工资时间范围"
  },
  applicationReview: {
    ApplyReason: "审批原因",
    ApproveOpinion: "审批意见",
    Approve: "待审核",
    // Passed: "审核通过",
    // Refused: "审核拒绝",
    Failed: "减免失败",
    Successful: "减免成功",
    ApproveRemark: "审批说明",
    Detailsofexemption: "减免详情",
    IsRepay: "是否有还款",
    Invalid: "已失效",
    completeTicket: '已完成'
  },
  OrderStatus: {
    PartiallyCompleted: '部分完成',
    PrecompleteStatus: '预完成状态',
    beyondCompareSubmitFailed: '超过可减免金额，提交失败',
    manuoverdueDays: '案件升级已发起，10分钟后结果将同步到群聊',
    manuoverdueDaysFailed: '升级失败，请重试'
  },
  QueryDimension: '查询维度',
  Call: '拨打',
  FirstCall: '首次拨打',
  Totalcall: '全部拨打',
  //=Aplicar motivo
  // "First login time today": "今天第一次登录时间",
  // "Last update time": "上次更新时间",
  // 'Assign Num': "分配数",
  // 'Group KPI repay amount': "小组目标回款金额",
  // 'KPI repay amount': "目标回款金额",
  // "login time": "登录时间",
  // "Half a month": "半月",
  // "That day": "当日",
  // "Target amount of returns": "目标回款金额",
  // "Tiempo de PTP is incorrect, please fill in again": "承诺还款时间不正确，请重新填写",
};
